<!-- 工单记录 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="工单编号">
              <j-input placeholder="请输入工单编号" v-model="queryParam.ticketsNum"></j-input>
            </a-form-item>
          </a-col> -->
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('联系电话')">
              <a-input :placeholder="$t('请输入联系电话')" v-model="queryParam.ticketsContactPhone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag v-model="queryParam.ticketsEmergency" :placeholder="$t('请选择工单紧急程度')" dictCode="ticketsEmergency" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单类型')">
              <a-select v-model="queryParam.ticketsType" :placeholder="$t('请选择工单类型')">
                <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                <a-select-option :value="1">{{ $t('工程报装') }}</a-select-option>
                <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="3" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('状态')">
              <a-select v-model="queryParam.workState" :placeholder="$t('请选择状态')">
                <a-select-option :value="3">{{ $t('全部') }}</a-select-option>
                <a-select-option :value="0">{{ $t('待办') }}</a-select-option>
                <a-select-option :value="1">{{ $t('已办') }}</a-select-option>
                <a-select-option :value="-1">{{ $t('已结束') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a-button type="primary" @click="handleAdd" icon="plus" style="margin-left: 8px">{{ $t('新建工单') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="ticketsState" slot-scope="text,record">
          <!-- 换表 -->
          <span v-if="record.ticketsType == 0">
            <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
            </template>
            <template v-else>
              {{meterTypeList[text]}}
            </template>
          </span>
          <!-- 工程报装 -->
          <span v-if="record.ticketsType == 1">
            <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
            </template>
            <template v-else>
              {{engineeringList[text]}}
            </template>
          </span>
          <!-- 故障报修 -->
          <span v-if="record.ticketsType == 2">
            <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
            </template>
            <template v-else>
              {{repairList[text]}}
            </template>
          </span>
        </template>
        <template slot="createBy" slot-scope="text, record">
          <span>{{text?text:$t('微信端游客')}}</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <workModal ref="modalForm"></workModal>
    <detailModal ref="detailForm" @ok="loadData"></detailModal>
    <!-- 故障报修 -->
    <RepairDetailModal ref="RepairDetailForm" @ok="loadData"/> <!-- 详情 -->
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import workModal from '@/views/workOrderManagement/workManagement/modules/workModal.vue'
  import detailModal from '@/views/workOrderManagement/workManagement/modules/detailModal.vue'
  import RepairDetailModal from '@/views/workOrderManagement/workManagement/modules/repairDetailModal.vue'//故障报修详情

  export default {
    name: 'workList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      workModal,
      detailModal,
      RepairDetailModal,
      JInput
    },
    data () {
      return {
        description: '工单管理页面',
        url: {
          list: "/jeecg-engineering/ticket/tickets/list",
          delete: "/jeecg-engineering/ticket/tickets/delete",
          deleteBatch: "/jeecg-engineering/ticket/tickets/deleteBatch",
          exportXlsUrl: "/jeecg-engineering/ticket/tickets/exportXls",
          importExcelUrl: "jeecg-engineering/ticket/tickets/importExcel",
          start: "/jeecg-engineering/ticket/tickets/startProcess/tickets",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
        },
        dictOptions:{},
        superFieldList:[],
        queryParam: {
          workState: 3
        },
      }
    },
    created() {
      this.getSuperFieldList();
    },
    mounted(){
      this.queryParam = {
        ticketsNum:this.$route.query && this.$route.query.ticketsNum || '',
        workState:3
      }
      this.loadData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('工单编号'),
            align:"center",
            dataIndex: 'ticketsNum',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单类型'),
            align:"center",
            dataIndex: 'ticketsType',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('换表')
              }else if(t == 1){
                return this.$t('工程报装')
              }else if(t == 2){
                return this.$t('故障报修')
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单紧急程度'),
            align:"center",
            dataIndex: 'ticketsEmergency',
            customRender: (text) => {
              return filterDictTextByCache('ticketsEmergency', text)
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单状态'),
            dataIndex: 'ticketsState',
            align:"center",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'ticketsState' }
          },
          {
            title: this.$t('当前节点处理人'),
            align:"center",
            dataIndex: 'approverName',
            customRender: (t,r,index) => {
              if(t){
                return t
              }else{
                return '/'
              }
            },
            width: 200,
            ellipsis: true,
          },
          // {
          //   title:'工单截止时间',
          //   align:"center",
          //   dataIndex: 'ticketsDeadline'
          // },
          // {
          //   title:'工单位置',
          //   align:"center",
          //   dataIndex: 'ticketsLocation'
          // },
          // {
          //   title:'工单事务分类',
          //   align:"center",
          //   dataIndex: 'ticketsTransaction'
          // },
          {
            title: this.$t('工单联系人'),
            align:"center",
            dataIndex: 'ticketsContact',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('联系电话'),
            align:"center",
            dataIndex: 'ticketsContactPhone',
            width: 150,
            ellipsis: true,
          },

          {
            title: this.$t('申请人'),
            align:"center",
            dataIndex: 'createBy',
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'createBy' }
          },
          {
            title: this.$t('申请时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('更新时间'),
            align:"center",
            dataIndex: 'updateTime',
            width: 150,
            ellipsis: true,
          },
          // {
          //   title:'历时',
          //   align:"center",
          //   dataIndex: 'diachronic',
          //   width: 150,
          //   ellipsis: true,
          // },
          {
            title: this.$t('来源'),
            align:"center",
            dataIndex: 'sourceType',
            customRender: (text) => {
              if(text == 1){
              return this.$t('小程序')
            }else if(text == 2){
              return this.$t('公众号')
            }else{
              return 'PC'
            }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      meterTypeList() {
        return [this.$t('未开启'),this.$t('换表登记'),this.$t('旧表审核'),this.$t('绑定新表'),this.$t('安装'),this.$t('审核工单')]
      },
      engineeringList() {
        return [this.$t('未开启'),this.$t('报装申请'),this.$t('报装受理'),this.$t('报装勘察设计'),this.$t('报装预算'),this.$t('报装审批'),this.$t('报装收费'),this.$t('报装施工'),this.$t('报装验收'),this.$t('报装建档')]
      },
      repairList() {
        return [this.$t('未开启'),this.$t('登记'),this.$t('接单'),this.$t('归档')]
      },
    },
    methods: {
      searchReset(){
        this.queryParam = {
          workState:3
        };
        this.loadData();
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'int',value:'ticketsType',text:'工单类型,0:换表'})
        fieldList.push({type:'string',value:'ticketsForeignId',text:'工单外键id'})
        fieldList.push({type:'string',value:'ticketsProcessKey',text:'工单流程key'})
        fieldList.push({type:'string',value:'ticketsNum',text:'工单编号'})
        fieldList.push({type:'string',value:'ticketsLocation',text:'工单位置'})
        fieldList.push({type:'string',value:'ticketsContact',text:'工单联系人'})
        fieldList.push({type:'string',value:'ticketsContactPhone',text:'联系电话'})
        fieldList.push({type:'int',value:'ticketsEmergency',text:'工单紧急程度'})
        fieldList.push({type:'int',value:'ticketsTransaction',text:'工单事务分类'})
        fieldList.push({type:'date',value:'ticketsDeadline',text:'工单截至时间'})
        fieldList.push({type:'string',value:'remark',text:'备注信息'})
        this.superFieldList = fieldList
      },
      handleEdit(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.edit(row,'edit');
        })
      },
      // 详情
      handleDetail(row){
        this.$nextTick(()=>{
          if(row.ticketsType == 0){
            this.$refs.detailForm.init(row);
          }else if(row.ticketsType == 1){
            this.$refs.EngineeringInstallationDetailForm.init(row,true);
          }else if(row.ticketsType == 2){
            this.$refs.RepairDetailForm.init(row);
          }
        })
      },
      // 开启
      handleStart(row){
        this.loading = true;
        postAction(this.url.start,{dataId:row.id,flowableKey:row.ticketsProcessKey}).then(res=>{
          if(res.success){
            this.$message.success(this.$t('开启成功'));
            this.loading = false;
            this.loadData();
          }else{
            this.$message.error(res.message);
            this.loading = false;
          }
        })
      },
      // 审核旧表
      handleOldAudit(row){
        this.$nextTick(()=>{
          this.$refs.auditForm.init(row);
        });
      },
      // 绑定新表
      handleNewMeter(row){
        this.$nextTick(()=>{
          this.$refs.newMeterForm.init(row);
        });
      },
      // 安装
      handleInstall(row){
        let params = {
          dataId: row.id,
          values: {
            dataId: row.id,
          },
          comment: ''
        }
        postAction(this.url.pass,params).then(res=>{
          if(res.success){
            this.$message.success(this.$t('安装成功'));
            this.loadData();
          }else{
            this.$message.error(res.message);
          }
        })
      },
      // 审核新表
      handleNewAudit(row){
        this.$nextTick(()=>{
          this.$refs.auditForm.init(row);
        });
      },
      // 工程报装-处理
      handleFlow(row){
        this.$nextTick(()=>{
          if(row.ticketsState == 2){//受理
            this.$refs.ExamineForm.edit(row,true);
          }else if(row.ticketsState == 3){//勘察设计
            this.$refs.SurveyInformationForm.edit(row,true);
          }else if(row.ticketsState == 4){//预算
            this.$refs.DrawingForm.edit(row,true);
          }else if(row.ticketsState == 5){//审批
            this.$refs.LeaderApprovalForm.edit(row,true);
          }else if(row.ticketsState == 6){//收费
            this.$refs.FinancialConfirmationForm.edit(row,true);
          }else if(row.ticketsState == 7){//施工
            this.$refs.EnterConstructionForm.edit(row,true);
          }else if(row.ticketsState == 8){//验收
            this.$refs.EngineeringAcceptanceForm.edit(row,true);
          }else if(row.ticketsState == 9){//建档
            this.$refs.putOnRecordForm.init(row,true);
          }
        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>